import IcClose from '../../assets/image/ic_x.svg';
import { useTranslation } from '../../hook/useTranslation';

const Title = ({ title }) => {
  return (
    <div className="text-[14px] text-[1C1C1C] w-full text-left font-[700] mb-[8px]">{title}</div>
  );
};
const DotText = ({ text }) => {
  return (
    <div className="w-full flex items-start justify-start gap-[8px]">
      <div className="flex items-start justify-start mt-[-4px]">･</div>
      <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
        {text}
      </div>
    </div>
  );
};
const Text = ({ text }) => {
  return (
    <div className="w-full flex items-start justify-start gap-[8px]">
      <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
        {text}
      </div>
    </div>
  );
};

function AgreementTextService({ onClose = () => {} }) {
  const { t } = useTranslation();
  return (
    <div className="w-full h-full flex flex-col items-center justify-start">
      <div className="w-full flex justify-end items-center gap-2">
        <button type="button" onClick={onClose} className="cursor-pointer">
          <img src={IcClose} alt="close" className="w-[24px] h-[24px]" />
        </button>
      </div>
      <div className="text-[18px] text-[#363636] w-full text-left font-[700] my-[20px]">
        {t('agreement.service.title')}
      </div>
      <div className="w-full flex flex-col justify-start items-start my-[20px] grow overflow-y-auto gap-[20px]">
        <Text text={t('agreement.service.content')} />
        <div>
          <Title title={t('agreement.service.item1_title')} />
          <DotText text={t('agreement.service.item1_desc1')} />
          <DotText text={t('agreement.service.item1_desc2')} />
        </div>
        <div>
          <Title title={t('agreement.service.item2_title')} />
          <DotText text={t('agreement.service.item2_desc1')} />
          <DotText text={t('agreement.service.item2_desc2')} />
          <DotText text={t('agreement.service.item2_desc3')} />
          <DotText text={t('agreement.service.item2_desc4')} />
        </div>
        <div>
          <Title title={t('agreement.service.item3_title')} />
          <DotText text={t('agreement.service.item3_desc1')} />
          <DotText text={t('agreement.service.item3_desc2')} />
        </div>
        <div>
          <Title title={t('agreement.service.item4_title')} />
          <Text text={t('agreement.service.item4_desc1')} />
        </div>
        <div>
          <Title title={t('agreement.service.item5_title')} />
          <DotText text={t('agreement.service.item5_desc1')} />
          <DotText text={t('agreement.service.item5_desc2')} />
        </div>
        <div>
          <Title title={t('agreement.service.item6_title')} />
          <Text text={t('agreement.service.item6_desc1')} />
          <div className="my-[20px]" />
          <Text text={t('agreement.service.item6_desc2')} />
        </div>
        <div className="mb-[20px]">
          <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
            {t('agreement.service.footer')}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgreementTextService;
